import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-goto',
  templateUrl: './goto.component.html',
  styleUrls: ['./goto.component.scss']
})
export class GotoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
